

document.addEventListener('setupCompleted', () => {

  const _win = window as any;

  _win.grecaptchaExecute('partner_form_ready').then(token => {
    console.log("captcha token", token);
  });

  $('#btnNavBecomePartner').hide();
  $('#btnNavBecomeDriver').hide();
  $('#btnNavLogin').hide();
  $('#btnNavRegister').text($('#restaurant-form-b').text());
  $('#btnNavRegister').unbind('click');
  $('#btnNavRegister').click(e => {
    e.preventDefault();
    showForm(null);
  });

  [$('#restaurantType_a'),$('#restaurantType_b'),$('#existingDelivery_a'),$('#existingDelivery_b')].forEach(radio => {
    radio.parent().click(e => {
      e.preventDefault();
      radio.prop("checked", true);
    });
  })

  const showForm = function (name) {
    $('#lblLocServeCheck').hide();
    $('#lblLocServeYes').hide();
    $('#lblLocServeNo').hide();
    $('#lblLocServeFail').hide();
    $(".modal").addClass('show');
    $("#menu_btn").hide();
    $("#btnNavRegister").hide();
    $(".modal-btn").show();
    if (name) {
      $('#name').val(name);
      $('#formTitle').text(`Get started, ${name}`);
    }
  }
  $("#restaurant-form-a").click(e => {
    e.preventDefault();
    showForm($('#inputRestaurantNameA').val());
  });
  $("#restaurant-form-b").click(e => {
    e.preventDefault();
    showForm($('#inputRestaurantNameB').val());
  });

  //#######################################################################################
  _win.onAutocompletedAddress = function(place) {
    $('#lblLocServeYes').hide();
    $('#lblLocServeNo').hide();
    $('#lblLocServeCheck').show();
    $('#lblLocServeFail').hide();
    _win.grecaptchaExecute('contact_form_submit').then(token => {
      axios.post('/api/submit/partner', {
        _reCaptchaToken: token,
        onlyCheckHub: true,
        business: {
          location: {
            place_id: place.place_id,
            formatted_address: place.formatted_address,
            address_components: place.address_components,
            geometry: {location: {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}}
          },
        },
      })
      .then(res => res.data)
      .then(function (body) {
        $('#lblLocServeCheck').hide();
        if (body.success) {
          if (body.data){
            $('#lblLocServeYes').show();
          } else {
            $('#lblLocServeNo').show();
          }
        } else {
          $('#lblLocServeFail').show();
        }
      })
      .catch(er => {
        $('#lblLocServeCheck').hide();
        $('#lblLocServeFail').show();
      });
    });
  };

  $("#submitForm").click(function (event) {
    event.preventDefault();

    let hasIssues = false;
    let focusField;
    if (!$('#name').val()) {
      $('#name').parent().addClass('error');
      if (!focusField) focusField = $('#name');
      hasIssues = true;
    }
    if (!_win.autocompletedAddress) {
      $('#addressSearchInput_simple').parent().addClass('error');
      if (!focusField) focusField = $('#addressSearchInput_simple');
      hasIssues = true;
    }
    if (!$('#clientname').val()) {
      $('#clientname').parent().addClass('error');
      if (!focusField) focusField = $('#clientname');
      hasIssues = true;
    }
    if (!$('#email').val()) {
      $('#email').parent().addClass('error');
      if (!focusField) focusField = $('#email');
      hasIssues = true;
    }
    if (!$('#number').val()) {
      $('#number').parent().addClass('error');
      if (!focusField) focusField = $('#number');
      hasIssues = true;
    }

    if (focusField) focusField.focus();
    if (hasIssues) return;

    const selectedRestaurantTypeId = $('input[name=restaurantType]:checked').attr('id');
    const selectedRestaurnatTypeText = $('label[for="'+selectedRestaurantTypeId+'"]').text();

    const selectedExistingDeliveryId = $('input[name=existingDelivery]:checked').attr('id');
    const selectedExistingDeliveryText = $('label[for="'+selectedExistingDeliveryId+'"]').text();

    const payload = {
      _reCaptchaToken: null,
      business: {
        name: $('#name').val(),
        foodTag: $('#foodtag').val(),
        location: {},
        about: selectedRestaurnatTypeText,
        deliveryPartners: selectedExistingDeliveryText,
        additionalInfo: $('#message').val(),
      },
      user: {
        name: $('#clientname').val(),
        email: $('#email').val(),
        role: $('#role').val(),
        contactNumber: $('#number').val(),
      }
    };
    const loc = _win.autocompletedAddress;
    if (loc) {
      payload.business.location = {
        place_id: loc.place_id,
        formatted_address: loc.formatted_address,
        address_components: loc.address_components,
        geometry: {location: {lat: loc.geometry.location.lat(), lng: loc.geometry.location.lng()}}
      }
    }

    $('#loader').show();

    _win.grecaptchaExecute('contact_form_submit').then(token => {
      payload._reCaptchaToken = token;
      if (token) axios.post('/api/submit/partner', payload)
      .then(res => res.data)
      .then(function (body) {
        //console.log(body); //response.data => {success:true}
        $('#loader').hide();
        if (body.success) {
          $("#step1").hide();
          $("#step2").show();
          $("#step2")[0].scrollIntoView();
        } else {
          //TODO: add error message
        }
      })
      .catch(function (error) {
        console.warn('Unable to submit partner form.');
        console.log(error);
        $(".modal").addClass('show');
        $('#loader').hide();
      });
      else {
        $(".modal").addClass('show');
        $('#loader').hide();
      }
    })
  });


});
